/* KIAURA tee pack selector.
   Pairs with snippets/tee-pack-selector.liquid, which renders in two parts:
   the tier row sits above the size picker, the extra color slots sit below the
   colorway row. So this is document scoped rather than rooted in one element.

   Page order:
     Pack   1 2 3 4 5
     Size   S M L XL        Symmetry's native picker
     Color 1                tee-colorway-nav, the page you are on
     Color 2..N             revealed as the pack grows

   Pack size is not a variant, so this only builds the cart: N line items of
   real variants. A native automatic quantity discount does the money.

   Everything is delegated on document so an AJAX colorway swap needs no
   re-init. window.__teePackSize carries the pack size across colorway swaps.

   The add to cart is the shared two-line button (snippets/kiaura-atc-button.liquid):
   one server-rendered span per size, each with its label, price, stock line and
   data-katc-state. Pack labels and totals are written INTO the visible span's
   line 1, never over the button, and pre-order is read from that span's state.
   The notify CTA beside it belongs to snippets/kiaura-restock.liquid. */
(function () {
  window.__teePackSize = 1;

  var _map = null;
  function map() {
    if (_map) return _map;
    var tag = document.querySelector('[data-tee-pack-map]');
    try { _map = tag ? JSON.parse(tag.textContent) : null; } catch (e) { _map = null; }
    return _map;
  }
  function resetMap() { _map = null; }

  function sectionEl() {
    var t = document.querySelector('[data-tee-pack-map]');
    return (t && t.closest('.shopify-section')) || document;
  }

  function selectedSize() {
    var m = map();
    if (!m) return null;
    var idField = sectionEl().querySelector('[name="id"]');
    if (!idField || !idField.value) return null;
    for (var c = 0; c < m.colorways.length; c++) {
      var vs = m.colorways[c].variants;
      for (var v = 0; v < vs.length; v++) {
        if (String(vs[v].id) === String(idField.value)) return vs[v].size;
      }
    }
    return null;
  }

  function variantFor(m, handle, size) {
    for (var c = 0; c < m.colorways.length; c++) {
      if (m.colorways[c].handle !== handle) continue;
      var vs = m.colorways[c].variants;
      for (var v = 0; v < vs.length; v++) if (vs[v].size === size) return vs[v];
    }
    return null;
  }

  function labelFor(m, handle) {
    for (var c = 0; c < m.colorways.length; c++) if (m.colorways[c].handle === handle) return m.colorways[c].label;
    return handle;
  }

  /* The URL carries the colorway's SLUG ("washed-black"), not its product
     handle ("heritage-tee-washed-black"). Same information, roughly half the
     characters, and it stays readable for a hand-built campaign link. Full
     handles are still accepted on the way in so links shared before this keep
     working. */
  function slugFor(m, handle) {
    if (!m) return handle;
    for (var i = 0; i < m.colorways.length; i++) {
      if (m.colorways[i].handle === handle) return m.colorways[i].slug || handle;
    }
    return handle;
  }

  function handleForToken(m, token) {
    if (!m || !token) return token;
    for (var i = 0; i < m.colorways.length; i++) {
      var c = m.colorways[i];
      if (c.handle === token || c.slug === token) return c.handle;
    }
    return token;
  }

  /* Off in production. Enable per session with ?teedebug=1 on the URL, or by
     setting __teeDebug = true in the console. */
  if (/[?&]teedebug=1/.test(window.location.search)) window.__teeDebug = true;
  /* Checked live, not captured once, so it can be switched on from the console
     mid-session: __teeDebug = true */
  function trace() {
    if (!window.__teeDebug) return;
    try { console.log.apply(console, ['[tee]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  /* SINGLE SOURCE OF TRUTH for pack size.

     The radios live inside the product section, and a colorway swap destroys
     and rebuilds that entire section from server HTML in which the FIRST tier
     is the one carrying the `checked` attribute. So DOM checked-state cannot be
     trusted to survive a swap, and anything that reads it as authoritative will
     silently disagree with what the shopper picked. The value lives on window
     instead, and the markup is re-synced from it. */
  function currentSize() {
    if (window.__teeState && window.__teeState.pack != null) return window.__teeState.pack;
    if (window.__teePackSize == null) {
      var q = parseInt(new URLSearchParams(window.location.search).get('pack'), 10);
      var checked = document.querySelector('input[name="tee-pack-size"]:checked');
      window.__teePackSize = q > 1 ? q : (checked ? parseInt(checked.value, 10) || 1 : 1);
    }
    return window.__teePackSize;
  }

  function setPackSize(size, why) {
    size = parseInt(size, 10) || 1;
    window.__teePackSize = size;
    if (window.__teeState) window.__teeState.pack = size;
    syncPackRadios(size);
    trace('setPackSize', size, why);
  }

  function syncPackRadios(size) {
    document.querySelectorAll('input[name="tee-pack-size"]').forEach(function (r) {
      var want = parseInt(r.value, 10) === size;
      if (r.checked !== want) r.checked = want;
    });
  }

  /* ---- persistent selection state ----------------------------------------
     Everything the shopper picked lives HERE, in memory, for the life of the
     tab. The URL is a mirror written afterwards, never the transport.

     Why: Symmetry's <variant-picker data-update-url="true"> rewrites the query
     string itself every time the variant changes. A colorway swap re-selects a
     size, which fires that rewrite, which wipes pack/colors/size from the URL
     AFTER we wrote them. Anything that round-trips selection through the URL
     therefore loses it on every swap. Three Nails and ASRV keep it in memory
     for exactly this reason. */
  var state = window.__teeState || (window.__teeState = { pack: null, size: null, slots: [] });

  function seedFromUrl() {
    var q = new URLSearchParams(window.location.search);
    var p = parseInt(q.get('pack'), 10);
    state.pack = p > 1 ? p : 1;
    state.slots = (q.get('colors') || '').split(',');
    state.size = q.get('size') || null;
    state.path = window.location.pathname;
    window.__teePackSize = state.pack;
    trace('seedFromUrl', JSON.stringify(state));
  }

  function applySizeName(name) {
    if (!name) return;
    var scope = sectionEl() || document;
    var radios = scope.querySelectorAll('input[type="radio"][name$="-option"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value !== name) continue;
      if (!radios[i].checked) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    var sel = scope.querySelector('select[name$="-option"]');
    if (sel && sel.value !== name) {
      sel.value = name;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function recordSizeFromDom() {
    var scope = sectionEl() || document;
    var r = scope.querySelector('input[type="radio"][name$="-option"]:checked');
    if (r) { state.size = r.value; return; }
    var sel = scope.querySelector('select[name$="-option"]');
    if (sel && sel.value) state.size = sel.value;
  }

  /* Push memory INTO whatever markup is currently on the page. Called on first
     load and again after every colorway swap, because the swap replaces the
     section with server HTML that knows nothing about the session. */
  function applyState() {
    var m = map();
    syncPackRadios(state.pack || 1);

    document.querySelectorAll('[data-tee-slot]').forEach(function (slot) {
      var n = parseInt(slot.getAttribute('data-tee-slot'), 10);
      slot.querySelectorAll('[data-tee-pick]').forEach(function (b) { b.classList.remove('is-selected'); });
      var token = state.slots[n - 2];
      if (!token) return;
      var target = slot.querySelector('[data-tee-pick="' + handleForToken(m, token) + '"]');
      if (target) target.classList.add('is-selected');
    });

    applySizeName(state.size);
    trace('applyState', JSON.stringify(state));
  }




  /* The URL mirrors the ENTIRE configuration, so refresh, back button and a
     pasted link all land where you left off instead of resetting to the first
     colorway at the smallest pack:

       /products/heritage-tee-washed-black?pack=3&colors=vintage-white,heritage-sand&size=M

     'variant' is deliberately stripped. Symmetry adds it, but the id is only
     valid for one colorway, so a stale one would fight the size restore on the
     next load. Size travels by name instead, which is colorway-independent. */
  function writeToUrl(size) {
    try {
      var q = new URLSearchParams(window.location.search);

      if (size > 1) q.set('pack', String(size));
      else q.delete('pack');

      var parts = [];
      document.querySelectorAll('[data-tee-slot]').forEach(function (slot) {
        var n = parseInt(slot.getAttribute('data-tee-slot'), 10);
        if (n > size) return;
        var picked = slot.querySelector('[data-tee-pick].is-selected');
        parts[n - 2] = picked ? slugFor(map(), picked.getAttribute('data-tee-pick')) : '';
      });
      for (var k = 0; k < parts.length; k++) if (parts[k] === undefined) parts[k] = '';
      var joined = parts.join(',').replace(/,+$/, '');
      if (joined.replace(/,/g, '')) q.set('colors', joined);
      else q.delete('colors');

      if (state.size) q.set('size', state.size);
      else q.delete('size');

      q.delete('variant');

      /* Own the PATH too, not just the query. After a colorway swap the path is
         the only thing that says which color you are on, and Symmetry's variant
         picker rewrites the whole URL from its own data-url. Sourcing it from
         state means the address bar always names the colorway actually shown. */
      var path = state.path || window.location.pathname;
      var qs = q.toString();
      var next = path + (qs ? '?' + qs : '');
      if (next === window.location.pathname + window.location.search) {
        trace('writeToUrl no-op, already', next);
        return;
      }
      trace('writeToUrl size=' + size + ' ->', next);
      window.history.replaceState(null, '', next);
    } catch (e) {
      /* Never let the mirror take the page down with it. */
      trace('writeToUrl failed', e && e.message);
    }
  }


  function tierFor(m, size) {
    for (var i = 0; i < m.tiers.length; i++) if (m.tiers[i].size === size) return m.tiers[i];
    return null;
  }

  /* Pack money, one formula for the headline price and the add to cart. */
  function packTotals(m, size, tier) {
    var gross = m.unit * size;
    var pct = (m.live && tier && tier.percent) ? tier.percent : 0;
    return { gross: gross, pct: pct, net: pct ? Math.round(gross * (1 - pct / 100)) : gross };
  }

  /* Ship date from snippets/tee-purchase-state.liquid, for the "Pre-order" line item property. */
  function shipDate() {
    var el = document.querySelector('[data-tee-purchase]');
    return (el && el.getAttribute('data-ship-date')) || '';
  }

  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/, ',');
  }

  /* The headline price IS the pack price. Rather than a second total lower down,
     this rewrites the theme's own price element, keeps its markup, and drives the
     Save / % OFF pills off the same numbers. Restores the original on pack 1. */
  /* Write only on an actual change. Reassigning identical innerHTML still tears
     down and rebuilds those nodes, which is the flicker -- same class of bug as
     the ATC label, and it fires on every render including ones triggered by
     unrelated state. */
  function setHtml(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }
  function setHidden(el, v) { if (el && el.hidden !== v) el.hidden = v; }

  /* Symmetry re-renders the price block on variant change, flashing the single
     price before our pack price returns. Re-assert in the same microtask.
     At size 1 we deliberately do nothing: the theme owns that price, and
     fighting it is what would cause a loop. */
  function ensurePriceWatch() {
    var box = document.querySelector('[data-tee-price]');
    if (!box || box.__teePriceWatched) return;
    box.__teePriceWatched = true;
    new MutationObserver(function () {
      var m = map();
      if (!m) return;
      var size = currentSize();
      if (size < 2) return;
      try { paintPrice(m, size, tierFor(m, size)); } catch (e) {}
    }).observe(box, { childList: true, subtree: true, characterData: true });
    trace('price watch attached');
  }

  function paintPrice(m, size, tier) {
    var box = document.querySelector('[data-tee-price]');
    if (!box) return;
    var cur = box.querySelector('.price__current .js-value');
    var was = box.querySelector('.price__was');
    var wasVal = was && was.querySelector('.js-value');
    var badges = box.querySelector('.tee-badges');
    if (!cur) return;

    if (box.__teeOrig === undefined) box.__teeOrig = cur.innerHTML;

    if (size < 2) {
      setHtml(cur, box.__teeOrig);
      setHidden(was, true);
      if (wasVal && wasVal.textContent !== '') wasVal.textContent = '';
      setHtml(badges, '');
      return;
    }

    var t = packTotals(m, size, tier);
    var gross = t.gross, pct = t.pct, net = t.net;

    setHtml(cur, '<span class="money">' + money(net) + '</span>');

    if (pct) {
      setHidden(was, false);
      setHtml(wasVal, '<span class="money">' + money(gross) + '</span>');
      setHtml(badges,
        '<span class="tee-badge">Save ' + money(gross - net) + '</span>' +
        '<span class="tee-badge">' + pct + '% OFF</span>');
    } else {
      setHidden(was, true);
      if (wasVal && wasVal.textContent !== '') wasVal.textContent = '';
      setHtml(badges, '');
    }
  }

  /* ---------------- pack slot previews, inside the native gallery ----------------
     Symmetry renders the same media twice: .product-media-collage__item for
     desktop and .slider__item for mobile. Rather than standing up a parallel
     grid (which caused a layout hop), tiles are CLONED from the first native
     item and appended to both containers, so they inherit the exact markup and
     the columns-2 layout for free.

       pack 1     every native tile visible, injected tiles removed
       pack >= 2  first native tile kept, the rest hidden,
                  N-1 injected tiles for slots 2..N
  */
  var GALLERY_BOXES = [
    { box: '.product-media-collage', item: '.product-media-collage__item' },
    { box: '.slider__grid',          item: '.slider__item' }
  ];

  function ordinal(n) {
    return n === 1 ? '1st' : n === 2 ? '2nd' : n === 3 ? '3rd' : n + 'th';
  }

  function colorwayFor(m, handle) {
    for (var i = 0; i < m.colorways.length; i++) {
      if (m.colorways[i].handle === handle) return m.colorways[i];
    }
    return null;
  }

  function ensurePlaceholder(tile) {
    var ph = tile.querySelector('[data-tee-ph]');
    if (ph) return ph;
    ph = document.createElement('div');
    ph.className = 'tee-slot-ph';
    ph.setAttribute('data-tee-ph', '');
    ph.innerHTML =
      '<span class="tee-slot-ph__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/>' +
      '<line x1="5" y1="12" x2="19" y2="12"/></svg></span>' +
      '<span class="tee-slot-ph__text" data-tee-ph-text></span>';
    tile.appendChild(ph);
    return ph;
  }

  /* Mobile pack grid. Every write is guarded so a render that changes nothing
     touches nothing -- the same rule that stopped the price and ATC flicker. */
  /* On mobile the info column stacks under the gallery, so at a pack the title
     ends up buried below a two-row grid. Lift it above the gallery instead.

     The node is MOVED rather than duplicated: a second copy would mean two h1s
     on the page. A comment node marks where it came from, so putting it back is
     exact rather than "append somewhere sensible". Both the gallery and the
     title live inside the product section, so a colorway swap rebuilds both and
     boot re-places it -- nothing leaks outside the section. */
  var TITLE_MQ = window.matchMedia('(max-width: 767.98px)');

  /* Title AND price ride above the gallery, in that order. Everything else --
     Pack, Size, the colorway pickers -- stays below it, so the first thing under
     the images is the thing you actually configure.

     Nodes are MOVED, never duplicated: a second copy would put two h1s and two
     price blocks on the page. A comment marks each one's origin so going back is
     exact rather than "append somewhere sensible". */
  /* Move the GALLERY down, not the title and price up.

     Moving title/price out of the info column looked right structurally but
     broke their styling: the theme scopes the h1 and the price block through
     ancestors (.product-info / .product-form / .detail), so relocating them
     outside that subtree silently dropped every one of those rules. The gallery
     styles itself through .media-gallery--* classes on its own element, so it
     is the piece that travels safely.

     Net effect is identical -- title, price, gallery, then Pack/Size/colors --
     with nothing restyled. One node moves instead of two, and a comment marks
     home so returning to Single is exact. */
  function placeTitle(size) {
    var gallery = document.querySelector('.media-gallery');
    if (!gallery || !gallery.parentNode) return;

    if (!gallery.__teeHome || !gallery.__teeHome.parentNode) {
      gallery.__teeHome = document.createComment('tee-gallery-home');
      gallery.parentNode.insertBefore(gallery.__teeHome, gallery);
    }

    /* Anchored to the TITLE, not the price: only the title rides above the
       gallery. Price stays with Pack / Size / colors underneath it. */
    var marked = document.querySelector('[data-tee-title]');
    var anchor = marked ? (marked.closest('.lightly-spaced-row') || marked) : null;
    var want = size > 1 && TITLE_MQ.matches && !!anchor;

    if (want) {
      if (anchor.nextSibling !== gallery) {
        anchor.parentNode.insertBefore(gallery, anchor.nextSibling);
        trace('gallery -> under price');
      }
    } else if (gallery.previousSibling !== gallery.__teeHome) {
      gallery.__teeHome.parentNode.insertBefore(gallery, gallery.__teeHome.nextSibling);
      trace('gallery -> home');
    }
  }

  /* Rotating the phone or resizing across the breakpoint has to re-evaluate. */
  if (TITLE_MQ.addEventListener) {
    TITLE_MQ.addEventListener('change', function () {
      try { placeTitle(currentSize()); } catch (e) {}
    });
  }

  /* Track the carousel's scroll position, not its slide-change event: the fill
     then follows the swipe continuously rather than jumping once the slide
     settles. translateX on a fill that is 1/n wide moves it exactly one slot
     per 100%, because a percentage transform resolves against the element's own
     width. */
  /* Both the pack grid and the progress bar are rendered in the info column
     and MOVED into .media-gallery, originally by an inline script during parse.
     A colorway swap replaces the whole section, which destroys the moved nodes,
     and the incoming markup arrives with fresh copies still sitting in the info
     column. That inline script cannot re-run: scripts parsed from innerHTML
     never execute. So the relocation has to happen again from here after every
     swap, or the bar simply vanishes on the second colorway.

     Idempotent, so calling it on every render costs a contains() check. */
  function placeGalleryExtras() {
    var host = document.querySelector('.media-gallery .main-image')
            || document.querySelector('.media-gallery .media-gallery__inner')
            || document.querySelector('.media-gallery');
    if (!host) return;

    var grid = document.querySelector('[data-tee-pack-gallery]');
    if (grid && !host.contains(grid)) host.insertBefore(grid, host.firstChild);

    var bar = document.querySelector('[data-tee-progress]');
    if (bar && !host.contains(bar)) host.appendChild(bar);
  }

  function initProgress() {
    var bar = document.querySelector('[data-tee-progress]');
    var slider = document.querySelector('.media-gallery .slider');
    if (!bar || !slider || slider.__teeProgress) return;
    slider.__teeProgress = true;

    function update() {
      var n = slider.querySelectorAll('.slider__item').length || 1;
      var max = slider.scrollWidth - slider.clientWidth;
      var p = max > 0 ? slider.scrollLeft / max : 0;
      bar.style.setProperty('--tee-progress-w', (100 / n) + '%');
      bar.style.setProperty('--tee-progress-x', (p * (n - 1) * 100) + '%');
    }

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    trace('progress bar wired');
  }



  /* Turn one pack tile into a mini gallery for the colorway sitting in it.

     Rebuilt only when the tile's colorway CHANGES, tracked on the node itself.
     Rebuilding every render would reset the shopper's scroll position inside
     the tile on every unrelated state change. */
  function buildTile(slot, key, media) {
    if (slot.__teeTileFor === key) return true;

    var oldScroller = slot.querySelector('[data-tee-tile]');
    if (oldScroller) oldScroller.remove();
    var oldDots = slot.querySelector('[data-tee-tile-dots]');
    if (oldDots) oldDots.remove();
    slot.__teeTileFor = key;

    if (!media || media.length < 2) return false;   // one photo needs no swiping

    var scroller = document.createElement('div');
    scroller.className = 'tee-tile';
    scroller.setAttribute('data-tee-tile', '');

    var track = document.createElement('div');
    track.className = 'tee-tile__track';

    media.forEach(function (mm) {
      var img = document.createElement('img');
      img.src = mm.src;
      img.alt = mm.alt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      track.appendChild(img);
    });

    scroller.appendChild(track);

    /* A line bar, not dots. Same component the single-pack gallery uses, so a
       tile reads like a small version of the main carousel rather than a
       different control. Driven by scrollLeft continuously and with no
       transition, for the same reason: easing a value that is already
       continuous reads as lag. */
    var bar = document.createElement('div');
    bar.className = 'tee-tile__bar';
    bar.setAttribute('data-tee-tile-dots', '');
    bar.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('span');
    fill.className = 'tee-tile__fill';
    bar.appendChild(fill);

    var raf = 0;
    function sync() {
      raf = 0;
      var n = media.length || 1;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var pos = max > 0 ? scroller.scrollLeft / max : 0;
      fill.style.setProperty('--tee-tile-w', (100 / n) + '%');
      fill.style.setProperty('--tee-tile-x', (pos * (n - 1) * 100) + '%');
    }
    scroller.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(sync);
    }, { passive: true });
    requestAnimationFrame(sync);

    slot.appendChild(scroller);
    slot.appendChild(bar);
    return true;
  }

  /* Keep whatever the shopper is looking at visually still while the gallery
     above it grows.

     The gallery sits ABOVE the pack, size and color controls on mobile, so
     adding a row pushes everything below it down by a full tile. Measure the
     controls, run the update, measure again, scroll by exactly the difference.
     The page still gains the pixels, it just does not appear to move.

     The scroll must be instant: with scroll-behavior:smooth in play an animated
     correction is its own visible jump. Done by hand because .tee-pack-gallery
     sets overflow-anchor:none, which switches off native anchoring. Tile height
     comes from aspect-ratio, so the measurement is right immediately and does
     not wait on image decoding.

     No viewport guard here on purpose. Correcting unconditionally is what makes
     it feel right; skipping the correction when the reference is off screen
     made it snap. */
  function preserveScroll(fn) {
    var ref = document.querySelector('[data-tee-slots]')
           || document.querySelector('[data-tee-packs]');
    if (!ref) { fn(); return; }

    var before = ref.getBoundingClientRect().top;
    fn();
    var delta = ref.getBoundingClientRect().top - before;
    if (!delta) return;

    var top = (window.pageYOffset || document.documentElement.scrollTop) + delta;
    try { window.scrollTo({ top: top, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, top); }
  }

  function renderPackGrid(m, size) {
    var g = document.querySelector('[data-tee-pack-gallery]');
    if (!g) return;

    if (size < 2) {
      if (!g.hidden) g.hidden = true;
      return;
    }
    if (g.hidden) g.hidden = false;

    /* Which of slots 2..size the shopper has actually chosen. Read first so the
       grid can size itself to real progress rather than to the pack. */
    var chosen = {};
    var filled = 0;
    for (var n = 2; n <= size; n++) {
      var picked = document.querySelector('[data-tee-slot="' + n + '"] [data-tee-pick].is-selected');
      if (picked) { chosen[n] = picked.getAttribute('data-tee-pick'); filled++; }
    }

    /* The grid GROWS as you pick. Landing on a 5-pack used to paint four empty
       boxes and eat most of the screen before you had done anything. Now it
       shows what you have plus a single next box, so the page stays short and
       the placeholder reads as the next action rather than a wall of holes.

       "First unfilled" rather than "filled + 1" because slots can be chosen out
       of order: the pickers below let you fill slot 3 before slot 2. */
    var nextEmpty = 0;
    for (var k = 2; k <= size; k++) {
      if (!chosen[k]) { nextEmpty = k; break; }
    }
    var remaining = (size - 1) - filled;

    g.querySelectorAll('[data-tee-gallery-slot]').forEach(function (slot) {
      var i = parseInt(slot.getAttribute('data-tee-gallery-slot'), 10);
      var img = slot.querySelector('[data-tee-gallery-img]');
      var ph = slot.querySelector('[data-tee-gallery-placeholder]');
      var phText = ph && ph.querySelector('.tee-pack-gallery__text');

      var show = i === 1 || !!chosen[i] || i === nextEmpty;
      if (i > size) show = false;
      if (slot.hidden === show) slot.hidden = !show;
      if (!show) return;

      var src = null, alt = '';
      if (i === 1) {
        var self = colorwayFor(m, m.current);
        if (m.media && m.media[0]) { src = m.media[0].src; alt = m.media[0].alt || ''; }
        else if (self) { src = self.image; alt = self.alt || self.label || ''; }
      } else if (chosen[i]) {
        var cw = colorwayFor(m, chosen[i]);
        if (cw) { src = cw.image; alt = cw.alt || cw.label || ''; }
      }

      if (src) {
        var media = null, key = null;
        if (i === 1) { media = m.media; key = m.current; }
        else if (chosen[i]) {
          var c2 = colorwayFor(m, chosen[i]);
          media = c2 && c2.media; key = chosen[i];
        }

        /* A swipeable tile replaces the still. If the colorway only has one
           photo buildTile returns false and the plain img stays. */
        var swiped = buildTile(slot, key, media);
        if (img) {
          if (swiped) { if (!img.hidden) img.hidden = true; }
          else {
            if (img.getAttribute('src') !== src) { img.src = src; img.alt = alt; }
            if (img.hidden) img.hidden = false;
          }
        }
        if (ph && !ph.hidden) ph.hidden = true;
      } else {
        buildTile(slot, null, null);
        if (img && !img.hidden) img.hidden = true;
        if (ph && ph.hidden) ph.hidden = false;
        /* Counts DOWN as slots fill, so the box always states what is left to
           do rather than which ordinal position it happens to be. */
        if (phText) {
          var want = remaining === 1 ? 'Pick 1 more color' : 'Pick ' + remaining + ' more colors';
          if (phText.textContent !== want) phText.textContent = want;
        }
      }
    });
  }

  function renderGallery(m, size) {
    GALLERY_BOXES.forEach(function (cfg) {
      var box = document.querySelector(cfg.box);
      if (!box) return;

      var kids = Array.prototype.slice.call(box.children);
      var originals = kids.filter(function (c) { return !c.hasAttribute('data-tee-injected'); });
      if (!originals.length) return;

      if (size < 2) {
        originals.forEach(function (o) { o.hidden = false; });
        box.querySelectorAll('[data-tee-injected]').forEach(function (n) { n.remove(); });
        return;
      }

      originals.forEach(function (o, i) { o.hidden = i !== 0; });

      var want = size - 1;
      var have = box.querySelectorAll('[data-tee-injected]');
      for (var i = have.length; i > want; i--) have[i - 1].remove();

      for (var n = box.querySelectorAll('[data-tee-injected]').length; n < want; n++) {
        var clone = originals[0].cloneNode(true);
        clone.setAttribute('data-tee-injected', String(n + 2)); // slot number
        clone.classList.remove('is-active');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        /* the cloned lightbox link would open the wrong image */
        clone.querySelectorAll('a[href]').forEach(function (a) { a.removeAttribute('href'); });
        box.appendChild(clone);
      }

      box.querySelectorAll('[data-tee-injected]').forEach(function (tile) {
        var slotNum = parseInt(tile.getAttribute('data-tee-injected'), 10);
        var pickSlot = document.querySelector('[data-tee-slot="' + slotNum + '"]');
        var picked = pickSlot && pickSlot.querySelector('[data-tee-pick].is-selected');
        var img = tile.querySelector('img');
        var ph = ensurePlaceholder(tile);

        if (picked) {
          var cw = colorwayFor(m, picked.getAttribute('data-tee-pick'));
          if (cw && cw.image && img) {
            img.removeAttribute('srcset');
            img.removeAttribute('data-srcset');
            img.setAttribute('src', cw.image);
            img.alt = cw.alt || '';
            img.style.visibility = '';
            ph.hidden = true;
            return;
          }
        }
        if (img) img.style.visibility = 'hidden';
        ph.hidden = false;
        var t = ph.querySelector('[data-tee-ph-text]');
        if (t) t.textContent = 'Pick your ' + ordinal(slotNum) + ' color';
      });
    });
  }

  function render() {
    var m = map();
    if (!m) { trace('render BAILED: no map'); return; }
    var size = currentSize();
    trace('render enter size=' + size);
    window.__teePackSize = size;

    document.querySelectorAll('[data-tee-tier]').forEach(function (t) {
      t.classList.toggle('is-active', parseInt(t.getAttribute('data-tee-tier'), 10) === size);
    });

    /* Color 1 is the colorway nav. Only number it once a pack is in play. */
    var navLabel = document.querySelector('[data-tee-color-label]');
    if (navLabel) navLabel.textContent = size > 1 ? 'Color 1' : 'Color';

    document.querySelectorAll('[data-tee-slot]').forEach(function (slot) {
      var n = parseInt(slot.getAttribute('data-tee-slot'), 10);
      slot.hidden = n > size;

      /* Slots start empty on purpose, same as Three Nails: landing on ?pack=3
         should show two placeholders, not silently pre-fill them. */
      var picked = slot.querySelector('[data-tee-pick].is-selected');
      var nameEl = slot.querySelector('[data-tee-slot-name]');
      if (nameEl) nameEl.textContent = picked ? labelFor(m, picked.getAttribute('data-tee-pick')) : '';
    });

    /* URL and the pre-paint flag sync FIRST. They used to run last, after the
       paint helpers, so any throw in those left the URL stuck on the old pack,
       and a colorway swap then carried that stale pack forward. */
    writeToUrl(size);
    if (size > 1) document.documentElement.setAttribute('data-tee-pack', String(size));
    else document.documentElement.removeAttribute('data-tee-pack');

    var tier = tierFor(m, size);

    /* Isolated so one failing painter cannot take the others down with it. */
    try { paintPrice(m, size, tier); } catch (e) {}
    try { paintButton(m, size, tier); } catch (e) {}
    try { ensurePriceWatch(); } catch (e) {}
    try { renderGallery(m, size); } catch (e) {}
    /* Must run BEFORE the grid and the bar are painted, so they are in the
       gallery by the time anything measures or fills them. */
    try { placeGalleryExtras(); } catch (e) {}
    try { renderPackGrid(m, size); } catch (e) {}
    try { placeTitle(size); } catch (e) {}
    try { initProgress(); } catch (e) {}

    document.dispatchEvent(new CustomEvent('tee:packchange', { detail: { size: size } }));
  }

  /* One button, never swapped. The two-line add to cart stays exactly where
     it is; only the text in its visible span and what the click does change.
     Swapping in a second button was what made the layout jump between pack
     sizes and pre-order. */
  function nativeAtc() {
    return document.querySelector('buy-buttons button[type="submit"][name="add"]');
  }

  /* The span for the selected size. variant-picker.js shows exactly one. */
  function atcSpan(btn) {
    btn = btn || nativeAtc();
    return btn ? btn.querySelector('.katc__v:not([hidden])') : null;
  }

  /* Pre-order means the selected size is at or below zero stock, which the server
     already worked out for that span (snippets/kiaura-variant-state.liquid). */
  function isPre() {
    var v = atcSpan();
    return !!v && v.getAttribute('data-katc-state') === 'pre';
  }

  /* What the server rendered into a span, kept so Single restores it exactly.
     __teeWrote tracks the last price markup written, so a currency app touching
     the .money spans cannot make the comparison flap. */
  function serverCopy(v) {
    if (!v.__teeServer) {
      var label = v.querySelector('.katc__label');
      var price = v.querySelector('.katc__price');
      var status = v.querySelector('.katc__status');
      var dot = v.querySelector('.katc__dot');
      v.__teeServer = {
        label: label ? label.textContent : '',
        price: price ? price.innerHTML : '',
        status: status ? status.textContent : '',
        dot: dot ? dot.className : ''
      };
      if (price) price.__teeWrote = v.__teeServer.price;
    }
    return v.__teeServer;
  }

  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function setClass(el, c) { if (el && c && el.className !== c) el.className = c; }
  function setPrice(el, html) {
    if (!el || el.__teeWrote === html) return;
    el.innerHTML = html;
    el.__teeWrote = html;
  }

  function packPriceHtml(t) {
    var was = t.pct
      ? '<s class="katc__was"><span class="visually-hidden">Regular price</span><span class="money">' + money(t.gross) + '</span></s>' +
        '<span class="visually-hidden">Sale price</span>'
      : '';
    return was + '<span class="katc__now"><span class="money">' + money(t.net) + '</span></span>';
  }

  /* Slots 2..size that still have no color chosen. */
  function missingSlotCount(size) {
    var missing = 0;
    document.querySelectorAll('[data-tee-slot]').forEach(function (slot) {
      var n = parseInt(slot.getAttribute('data-tee-slot'), 10);
      if (n > size) return;
      if (!slot.querySelector('[data-tee-pick].is-selected')) missing++;
    });
    return missing;
  }

  /* How many units of this pack cannot actually be fulfilled right now.

     The add to cart's pre-order state only ever describes the CURRENT colorway,
     because it is derived from the selected variant. That misses the case that matters
     here: viewing Washed Black, which is in stock, with a sold out color chosen
     in slot 2. The pack has to judge itself. */
  function packShortfall(m, size) {
    var sizeName = selectedSize();
    if (!m || !sizeName) return 0;

    var handles = [m.current];
    for (var n = 2; n <= size; n++) {
      var picked = document.querySelector('[data-tee-slot="' + n + '"] [data-tee-pick].is-selected');
      if (picked) handles.push(picked.getAttribute('data-tee-pick'));
    }

    var need = {};
    handles.forEach(function (h) {
      var v = variantFor(m, h, sizeName);
      if (v) need[v.id] = (need[v.id] || { v: v, qty: 0 }), need[v.id].qty++;
    });

    var short = 0;
    Object.keys(need).forEach(function (id) {
      var have = Math.max(0, parseInt(need[id].v.inventory, 10) || 0);
      if (need[id].qty > have) short += need[id].qty - have;
    });
    return short;
  }

  function paintButton(m, size, tier) {
    var btn = nativeAtc();
    if (!btn) return;
    var pre = isPre();
    /* Block the action up front rather than accepting the click and then
       showing an error underneath. Only ever ADD the disabled state, and only
       remove one we set ourselves, so a genuinely sold out variant that the
       theme disabled does not get re-enabled by us. */
    var missing = size > 1 ? missingSlotCount(size) : 0;
    var blocked = missing > 0 && !pre;

    if (blocked) {
      if (!btn.disabled) { btn.disabled = true; btn.__teeDisabledByUs = true; }
      btn.setAttribute('aria-disabled', 'true');
    } else if (btn.__teeDisabledByUs) {
      btn.disabled = false;
      btn.__teeDisabledByUs = false;
      btn.removeAttribute('aria-disabled');
    }

    var short = 0;
    try { short = packShortfall(m, size); } catch (e) {}
    window.__teePackShort = short;

    /* Single is the server render as is: label, price, and the in / low / pre
       stock line. A pack changes line 1 to the pack label and pack total, and
       line 2 to the pre-order line when any unit of it has to pre-order. */
    var v = atcSpan(btn);
    if (!v) return;
    var base = serverCopy(v);
    var label = base.label, price = base.price, status = base.status, dot = base.dot;

    if (size > 1 && tier) {
      price = packPriceHtml(packTotals(m, size, tier));
      if (blocked) {
        label = missing === 1 ? 'Pick 1 more color' : 'Pick ' + missing + ' more colors';
      } else if (short > 0) {
        /* Deliberately vague. No date, no window, no promise we cannot keep. */
        label = 'Pre-order ' + tier.title;
        status = btn.getAttribute('data-katc-pre-line') || status;
        dot = 'katc__dot katc__dot--pre';
      } else {
        label = 'Add ' + tier.title + ' to cart';
      }
    }

    setText(v.querySelector('.katc__label'), label);
    setPrice(v.querySelector('.katc__price'), price);
    setText(v.querySelector('.katc__status'), status);
    setClass(v.querySelector('.katc__dot'), dot);
  }

  function addPack() {
    var m = map();
    if (!m) return;
    var size = currentSize();
    var sizeName = selectedSize();
    var err = document.querySelector('[data-tee-pack-error]');
    var btn = nativeAtc();

    function fail(msg) { if (err) { err.textContent = msg; err.hidden = false; } }
    if (err) err.hidden = true;
    if (!sizeName) return fail('Pick a size first.');

    var handles = [m.current];
    var missing = false;
    document.querySelectorAll('[data-tee-slot]').forEach(function (slot) {
      var n = parseInt(slot.getAttribute('data-tee-slot'), 10);
      if (n > size) return;
      var picked = slot.querySelector('[data-tee-pick].is-selected');
      if (!picked) { missing = true; return; }
      handles.push(picked.getAttribute('data-tee-pick'));
    });
    /* Unreachable in normal use now: the button is disabled until every slot
       is filled. Kept as a backstop in case something is added to the cart by
       another path, but it no longer doubles as the primary prompt. */
    if (missing) return fail('Pick a color for every tee.');

    /* Tally first. The same colorway can occupy several slots, so what matters
       is units per VARIANT, not per slot: three slots of Washed Black / M needs
       three units of one variant, and stock has to be measured against that. */
    var need = [];
    var byId = {};
    for (var i = 0; i < handles.length; i++) {
      var v = variantFor(m, handles[i], sizeName);
      if (!v) return fail('That size is not available in one of the colors you picked.');
      if (byId[v.id] === undefined) { byId[v.id] = need.length; need.push({ v: v, qty: 0 }); }
      need[byId[v.id]].qty += 1;
    }

    /* Never block the sale. Variants are CONTINUE policy, so Shopify accepts
       the order either way; the job here is to be honest about which units are
       physically on hand and to tag the rest so the cart, the order and any
       downstream flow can see it.

       A variant that is partly available splits into TWO lines: the units in
       stock, and the units beyond it carrying the property. Shopify merges
       lines by variant AND properties, so differing properties is exactly what
       keeps them apart. */
    /* Key is "Pre-order" so the cart line reads "Pre-order : ...", same shape
       Haus uses. Without a ship date it promises fulfilment within 60 days, the
       window Haus runs on (Nick, 10/23/26). */
    var when = shipDate();
    var label = when
      ? 'Ships ' + when
      : 'Fulfills within 60 days';

    var items = [];
    var preorderUnits = 0;
    for (var k = 0; k < need.length; k++) {
      var have = Math.max(0, parseInt(need[k].v.inventory, 10) || 0);
      var inStock = Math.min(need[k].qty, have);
      var pre = need[k].qty - inStock;

      if (inStock > 0) items.push({ id: need[k].v.id, quantity: inStock });
      if (pre > 0) {
        preorderUnits += pre;
        items.push({ id: need[k].v.id, quantity: pre, properties: { 'Pre-order': label } });
      }
    }
    window.__teePackPreorderUnits = preorderUnits;
    trace('addPack', JSON.stringify(items));

    /* The theme's own loader (main.css .is-loading), as for a single add; the
       button's spans stay intact underneath it. */
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      })
      .catch(function () { fail('Could not add that pack. Try again.'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); render(); }
      });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    trace('change evt name=' + (t.name || '?') + ' value=' + (t.value || '?'));
    if (t.matches('input[name="tee-pack-size"]')) {
      setPackSize(t.value, 'tier click');
      preserveScroll(render);
    }
    /* Symmetry's size radios. <variant-picker data-update-url="true"> clobbers
       the query string on every size change, so we must rewrite it ourselves
       right after. The button is repainted from on:variant:change below, once
       the picker has shown the new size's span. */
    else if (t.matches('input[name$="-option"]') || t.matches('select[name$="-option"]')) {
      state.size = t.value;
      trace('size ->', t.value);
      try {
        var mm = map();
        if (mm) { var cs = currentSize(); paintPrice(mm, cs, tierFor(mm, cs)); }
      } catch (e) {}
      setTimeout(render, 0);
    }
    else if (t.matches('[name="id"]')) setTimeout(render, 0);
  }, true);

  /* variant-picker.js has just shown the new size's span (same task, before
     paint), so writing the pack label now means the server label for a single
     never reaches the screen. */
  document.addEventListener('on:variant:change', function () {
    var m = map();
    if (!m) return;
    var size = currentSize();
    try { paintButton(m, size, tierFor(m, size)); } catch (e) {}
  });

  /* Capture phase so we beat Symmetry's own form handler. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('buy-buttons button[name="add"]');
    /* Runs in preorder as well. It used to bail here, which handed the click
       back to Symmetry's native form -- and that adds ONE variant, not the
       pack. A shopper on a 5-Pack saw $171, tapped Pre-order, and got a single
       $60 tee. */
    /* Singles normally use Symmetry's native form, which cannot attach a line
       item property. When the item is a pre-order we have to take the click so
       the cart line is tagged. */
    if (btn && (currentSize() > 1 || isPre() || window.__teePackShort > 0)) {
      e.preventDefault(); e.stopPropagation();
      addPack();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (currentSize() > 1 && !isPre() &&
        e.target && e.target.matches && e.target.matches('form.js-product-form')) {
      e.preventDefault(); e.stopPropagation();
      addPack();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var pick = e.target.closest && e.target.closest('[data-tee-pick]');
    if (pick) {
      var slot = pick.closest('[data-tee-slot]');
      if (slot) {
        slot.querySelectorAll('[data-tee-pick]').forEach(function (b) { b.classList.remove('is-selected'); });
        pick.classList.add('is-selected');
        var sn = parseInt(slot.getAttribute('data-tee-slot'), 10);
        state.slots[sn - 2] = slugFor(map(), pick.getAttribute('data-tee-pick'));
        trace('slot ' + sn + ' ->', state.slots[sn - 2]);
        preserveScroll(render);
      }
      return;
    }
  });

  /* first=true only on a genuine page load. A colorway swap must NOT re-read
     the URL, because Symmetry may already have rewritten it. */
  function boot(first) {
    if (first) seedFromUrl();
    applyState();
    render();
  }

  /* Symmetry's variant picker is a web component. If it had not upgraded yet
     the boot-time change event went nowhere, so re-assert once on load. */
  window.addEventListener('load', function () { applyState(); render(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(true); });
  else boot(true);

  /* Colorway swap: the section markup is new, so drop the cached map and
     re-place the grid in the same task the swap happened in. */
  document.addEventListener('tee:swapped', function () {
    resetMap();
    boot(false);
    /* Symmetry's variant picker rewrites the URL on the change event that the
       swap's size restore fires. Re-assert on the next frame so our mirror is
       the last write, not the one that gets clobbered. */
    /* Two passes on purpose. The variant picker's URL rewrite is triggered by
       the change event our size restore fires, and it does not always land in
       the same frame, so one re-assert can still lose the race. Both passes are
       idempotent -- writeToUrl bails when the URL already matches. */
    requestAnimationFrame(function () { recordSizeFromDom(); render(); });
    setTimeout(function () { recordSizeFromDom(); render(); }, 80);
  });

  /* AJAX colorway swap replaces the section; the map is new, so drop the cache. */
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('[data-tee-pack-map]')) ||
            (n.querySelector && n.querySelector('[data-tee-pack-map]'))) {
          resetMap();
          setTimeout(function () { boot(false); }, 0);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
